import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { buttonVariants } from '@/components/ui/button';
import { useDocumentTitle } from '@/hooks/use-document-title';
import { cn } from '@/lib/utils';

/** `*` — the catch-all route (05 §1.2). */
export default function NotFoundPage() {
  const { t } = useTranslation();
  useDocumentTitle(t('pages.notFound.title'));

  return (
    <div className="grid min-h-[50vh] place-items-center text-center" data-testid="not-found-page">
      <div className="max-w-md space-y-3">
        <p className="text-5xl font-semibold text-muted-foreground tabular">404</p>
        <h1 className="text-xl font-semibold">{t('pages.notFound.title')}</h1>
        <p className="text-sm text-muted-foreground">{t('pages.notFound.description')}</p>
        <Link to="/" className={cn(buttonVariants({ variant: 'default' }))}>
          {t('pages.notFound.goHome')}
        </Link>
      </div>
    </div>
  );
}
